import React, { useEffect, useState } from 'react';
import './style.css';

const BackToTop = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => setVisible(window.scrollY > 500);
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <button
            type="button"
            className={`back-to-top ${visible ? 'visible' : ''}`}
            onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
            aria-label="Back to top"
        >
            <span aria-hidden="true" />
        </button>
    );
};

export default BackToTop;
